<div class="container col-sm-10 col-md-8 col-lg-6 col-xl-4 my-2">
    <div class="mx-auto vstack gap-3 text-center">
        <h1 class="text-success display-4">
            <i class="bi bi-check-circle"></i>
        </h1>
        <h1 class="display-7">Thank you for taking the time to leave us a review - it's very appreciated!</h1>
    </div>
</div>
